import { motion } from "framer-motion";
import { ArrowRight, Car } from "lucide-react";
import { TRANSFERS } from "@/lib/constants";
import { useLang } from "@/lib/i18n";

export const Transfers = () => {
  const { t } = useLang();
  return (
    <section className="section tinted" id="transfers">
      <div className="section-heading">
        <div>
          <div className="eyebrow">{t.transfers.eyebrow}</div>
          <h2>{t.transfers.title}</h2>
        </div>
        <p>{t.transfers.intro}</p>
      </div>
      <div className="transfer-layout">
        <motion.div
          className="transfer-visual"
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          data-testid="transfer-visual"
        >
          <img src="/images/transfer.webp" alt="Sedan waiting at airport pickup lane — illustrative" loading="lazy" />
          <span className="media-tag">{t.rooms.aiTag.split("·")[0].trim()}</span>
        </motion.div>
        <div className="transfer-grid">
          {TRANSFERS.map((transfer, index) => (
            <motion.article
              className="transfer-card"
              key={transfer.type}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.12, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`transfer-card-${index + 1}`}
            >
              <div className="transfer-icon">
                <Car size={24} />
              </div>
              <div>
                <h3>{transfer.type}</h3>
                <p>{t.transfers.detail}</p>
              </div>
              <div className="transfer-prices">
                <span>
                  <small>{t.transfers.pickup}</small>
                  <strong>{transfer.pickup}</strong>
                </span>
                <span>
                  <small>{t.transfers.drop}</small>
                  <strong>{transfer.drop}</strong>
                </span>
              </div>
              <a href="#enquiry" className="text-link" data-testid={`transfer-enquire-${index + 1}`}>
                {t.transfers.ask} <ArrowRight size={15} />
              </a>
            </motion.article>
          ))}
        </div>
      </div>
      <p className="fine-print">{t.transfers.finePrint}</p>
    </section>
  );
};
